<nz-card>
  
  <div class="row">
    <app-search-filter [total]="queryParams.totalItems" (search$)="getValueSearch($event)">
      <div class="row m-b-30">
        <div class="col-lg-12">
          <div class="d-md-flex">
            <nz-input-group [nzPrefix]="prefixTemplate">
              <input type="text" nz-input placeholder="Mã sản phẩm" [(ngModel)]="searchParams.code" 
              (ngModelChange)="eventSearchParams('code', searchParams.code)">
            </nz-input-group>
            <ng-template #prefixTemplate>
              <i nz-icon nzType="search" class="opacity-05"></i>
            </ng-template>
          </div>
        </div>
      </div>
    </app-search-filter>
  </div>
  <nz-divider></nz-divider>
  <nz-table #listViewTable [nzData]="list" [nzShowPagination]="false" [nzFrontPagination]="false">
    <thead>
    <tr>
      <th>Tên</th>
      <th>Mã sản phẩm</th>
      <th>NAV</th>
      <th>Tổng giá trị phát hành</th>
      <th>Ngày kết thúc phát hành</th>
      <th>Tổng giá trị</th>
      <th>Kích hoạt	</th>
      <th>Action</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of listViewTable.data; trackBy: trackId">
      <td>{{item.name}}</td>
      <td>{{item.code}}</td>
      <td>{{item.nav}}</td>
      <td>{{item.totalReleaseValue}}</td>
      <td>{{item.endDate}}</td>
      <td>{{item.totalValue}}</td>
      <td>{{item.status}}</td>
      <td>
        <!-- <a class="m-r-5" nz-popconfirm nzPopconfirmTitle="Are you sure to block user?"
           (nzOnConfirm)="confirmDelete(item.id)"
           (nzOnCancel)="cancelDelete()">
          <i nz-icon nzType="down" theme="outline"></i>
        </a> -->
      </td>
    </tr>
    </tbody>
  </nz-table>
  <div class="ant-table-pagination ant-pagination">
    <nz-pagination [nzPageIndex]="queryParams.page" [nzTotal]="queryParams.totalItems" [nzPageSize]="queryParams.size"
                   [nzShowTotal]="rangeTemplate" (nzPageIndexChange)="loadPage($event)"></nz-pagination>
    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }} - {{ range[1] }} of {{ queryParams.totalItems }} items
    </ng-template>
  </div>
</nz-card>
